import { SVGProps } from "react";

const PlusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_757_3294)">
        <path
          d="M10.9286 5.91545H7.28572C7.16738 5.91545 7.07143 5.8195 7.07143 5.70116V2.05831C7.07143 1.46661 6.59169 0.986877 6 0.986877C5.40831 0.986877 4.92857 1.46661 4.92857 2.05831V5.70116C4.92857 5.8195 4.83262 5.91545 4.71429 5.91545H1.07143C0.479736 5.91545 0 6.39519 0 6.98688C0 7.57857 0.479736 8.05831 1.07143 8.05831H4.71429C4.83262 8.05831 4.92857 8.15425 4.92857 8.27259V11.9155C4.92857 12.5071 5.40831 12.9869 6 12.9869C6.59169 12.9869 7.07143 12.5071 7.07143 11.9155V8.27259C7.07143 8.15425 7.16738 8.05831 7.28572 8.05831H10.9286C11.5203 8.05831 12 7.57857 12 6.98688C12 6.39519 11.5203 5.91545 10.9286 5.91545Z"
          fill="#1F1F1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_757_3294">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.986877)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PlusIcon;
